import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {Button, Space, Upload} from 'antd';
import {PlusOutlined} from '@ant-design/icons';
import {StyledInvoiceTypeSelectorOutlineButton} from './StyledInvoiceTypeSelector';

const uploadProps = {
  accept: '.jpeg,.jpg,.png,.pdf',
  customRequest: () => null,
  maxCount: 1,
  multiple: false,
  showUploadList: false,
}

const InvoiceTypeSelector = ({
  onAdd,
  onEdit,
  ...rest
}) => {
  const [t] = useTranslation('main');
  const [editBtnProps, setEditBtnProps] = useState({loading: false});

  const handleEdit = (e) => {
    if (onEdit) {
      setEditBtnProps({...editBtnProps, loading: true});
      onEdit(e, () => {
        setEditBtnProps({...editBtnProps, loading: false});
      });
    }
  }

  const handleUpload = ({ fileList }) => {
    onAdd && onAdd(fileList);
  }

  return (
    <Space
      size='small'
      {...rest}
    >
      <Upload
        {...uploadProps}
        onChange={handleUpload}
      >
        <Button
          icon={<PlusOutlined />}
          size='middle'
          type='primary'
        >
          {t('invoice')}
        </Button>
      </Upload>
      <StyledInvoiceTypeSelectorOutlineButton
        {...editBtnProps}
        onClick={handleEdit}
        size='middle'
      >
        {t(`invoiceTypes.noReceipt`)}
      </StyledInvoiceTypeSelectorOutlineButton>
    </Space>
  );
}

InvoiceTypeSelector.propTypes = {
  onAdd: PropTypes.func,
  onEdit: PropTypes.func,
}

export default InvoiceTypeSelector;
